// src/utils/consentimientoGeneral.js
export const CONSENTIMIENTO_GENERAL_TXT = `
CONSENTIMIENTO Y RELEVO DE RESPONSABILIDAD

Yo {{CLIENTE_NOMBRE_COMPLETO}} con fecha de nacimiento {{FECHA_NACIMIENTO}}, y licencia {{CLIENTE_LICENCIA}}, declaro que entiendo que los tratamientos recibidos no son sustitutos de tratamientos médicos. He provisto información real y al detalle a mi entender completamente.

He notificado a la esteticista sobre mis alergias y condiciones médicas actuales y pasadas de forma veraz. En caso de que, durante el tratamiento, la esteticista considere que mi conducta es inapropiada, irrespetuosa o le causa incomodidad de cualquier forma, se reserva el derecho de detener el servicio de inmediato. En tal caso, entiendo y acepto que deberé abonar el monto total del servicio, sin derecho a reembolso ni reprogramación de la cita.

Acepto recibir el servicio solicitado y seguir las instrucciones provistas por la esteticista Stephanie Robles Cintrón sobre recomendaciones posteriores al tratamiento. Relevo a Stephanie Robles Cintrón de toda responsabilidad legal sobre los tratamientos realizados, en tanto la información brindada haya sido exacta.

Acepto la toma de fotos y videos para fines de historial clínico y seguimiento del tratamiento.

Acepto la toma de fotos y videos con fines promocionales o de redes sociales, siempre que mi rostro no sea visible.

Fecha de aceptación: {{FECHA_FIRMA}}

Al marcar la casilla de aceptación, {{CLIENTE_NOMBRE_COMPLETO}} manifiesta su consentimiento total a los términos aquí descritos, conforme a la Ley de Firma Electrónica de PR y disposiciones contractuales vigentes.
`;

export const CONSENTIMIENTO_GENERAL_ID = "consentimiento_general";
export const CONSENTIMIENTO_GENERAL_VERSION = "v2.0";
